<template>
  <div class="page_box">
    <div class="page_option_box">
      <div></div>
      <div class="title-box">
        学校资料
      </div>
      <div></div>
    </div>
    <div class="page_table_box">
      <div class="list-box">
        <div class="li">
          <div class="li-title">资料模板:</div>
          <div style="margin-left:10px">
            <el-button
              type="primary"
              size="small"
              icon="el-icon-download"
              plain
              @click="
                $Common.fileDownloads(
                  'files/templates/学校双重预防建设资料模板.zip'
                )
              "
              >下载
            </el-button>
          </div>
        </div>
        <div class="li">
          <div class="li-title">学校资料:</div>
          <div class="select">
            <el-upload
              class="upload-demo"
              action=""
              :show-file-list="false"
              accept=".doc,.docx,.pptx,.xls,.xlsx,.pdf,.png,.jpg,.jpeg"
              :http-request="upload"
            >
              <el-button
                size="small"
                type="primary"
                class="el-icon-upload"
                plain
                >上传</el-button
              >
            </el-upload>
            <el-button
              class="download"
              plain
              type="primary"
              size="small"
              icon="el-icon-download"
              v-if="materialUrl"
              @click="dowload"
            >
              下载
            </el-button>
          </div>
        </div>
        <div class="li">
          <div class="li-title">
            文件名:
            <el-link
              type="primary"
              style="margin-left:10px"
              @click="filePreview(materialUrl)"
              >{{ materialUrl }}</el-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "schoolData",
  data() {
    return {
      schoolId: parseInt(this.$store.state.schoolId),
      materialUrl: ""
    };
  },
  created() {
    this.getList();
  },
  mounted() {},
  computed: {
    userInfo() {
      return this.$store.getters.getUserInfo;
    }
  },
  methods: {
    async getList() {
      let req = {
        schoolId: this.schoolId
      };
      let res = await this.$Http.getSchoolInfoData(req);
      if (res.code == 200) {
        this.materialUrl = res.data || "";
      } else if (res.code == 101) {
        this.materialUrl = "";
      } else {
        this.$message({
          type: "",
          message: res.messsage
        });
      }
    },
    dowload() {
      let materialUrl = this.materialUrl;
      this.$Common.fileDownloads(materialUrl);
    },
    // onSuccess(res, file) {
    //   this.materialUrl = Object.values(res.data)[0];
    //   console.log(22222)
    //   console.log(this.materialUrl)
    //   this.upload();
    // },
    async upload(event) {
      // console.log(event);
      // return
      let res = await this.$Common.fileUploadNew(event);
      // console.log(res);
      this.materialUrl = res.fileUrl;
      this.uploadFile();
    },

    async uploadFile() {
      // console.log(1111);
      let req = {
        schoolId: this.schoolId,
        materialUrl: this.materialUrl
      };
      let res = await this.$Http.addSchoolInfoData(req, true);
      if (res.code == 200) {
        this.$message({
          message: "上传成功！",
          type: "success"
        });
        this.getList();
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },
    // 文件预览
    async filePreview(url) {
      if (!url) {
        this.$message({
          message: "当前文件为空，请联系管理员...",
          type: "warning"
        });
      } else {
        let filePath = this.$store.state.config.fileUrl + url;
        let urlSuffix = url.split(".").pop();
        if (
          urlSuffix == "pdf" ||
          urlSuffix == "png" ||
          urlSuffix == "jpg" ||
          urlSuffix == "jpeg"
        ) {
          window.open(filePath);
        } else {
          window.open(
            "https://view.officeapps.live.com/op/view.aspx?src=" +
              encodeURIComponent(filePath)
          );
        }
      }
    }
  }
};
</script>
<style scoped lang="scss">
.list-box {
  padding: 50px;
  background: #ffffff;
  // box-shadow: 0px 0px 16px 0px #e6e3e3;
  border-radius: 8px;
  height: 100%;
  .li {
    margin-bottom: 30px;
    margin-left: 10px;
    display: flex;
    align-items: center;
  }
  .li-title {
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    display: flex;
    align-items: center;
  }
  .select {
    display: flex;
    align-items: center;
    margin-left: 10px;
    .download {
      margin-left: 20px;
    }
  }
}
.title-box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
}
</style>
